import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useNullableDealerAccountInfo } from "../../../../../stores/hooks/useNullableDealerAccountInfo";
import { usePanelState } from "../../../../../stores/hooks/usePanelState";
import { Checkbox } from "../../../../../ui/Checkbox/Checkbox";
import { Collapsible } from "../../../../../ui/CollapsiblePannel/Collapsible";
import { useTireCategories } from "./useTireCategories";
import { useTireCategoryOptions } from "./useTireCategoryOptions";

const id = "tire-categories-panel";

export const TireCategoryFilters: FunctionComponent = () => {
  const [panelIsOpen, togglePanel] = usePanelState(id, true);
  const { t } = useTranslation();
  const [, { toggle }] = useTireCategories();
  const options = useTireCategoryOptions();
  const dealer = useNullableDealerAccountInfo();
  if (!dealer?.dealerProductFilters.categoryFilter) {
    return null;
  }
  return (
    <Collapsible
      className=" space-y-2"
      id={id}
      label={t("searchResults.categories")}
      onToggle={togglePanel}
      visible={panelIsOpen}
    >
      {options.map(({ checked, name, value }) => (
        <label className="flex items-center gap-x-4" key={value}>
          <Checkbox
            onChange={(): void => {
              toggle([value]);
            }}
            checked={checked}
            name="vehicleSubmodelTiresizeId"
            value={value}
          />
          <span className="flex-1 w-full">{name}</span>
        </label>
      ))}
    </Collapsible>
  );
};
